import React from "react";
import {
    TimelineItem,
    Timeline,
    TimelineOppositeContent,
    TimelineDot,
    TimelineConnector,
    TimelineContent, TimelineSeparator
} from "@mui/lab";
import MailIcon from '@mui/icons-material/Mail';
import GestureIcon from '@mui/icons-material/Gesture';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export default function CommissionTimeline() {
    return <Timeline position="alternate">
        <TimelineItem>
            <TimelineSeparator>
                <TimelineDot>
                    <MailIcon/>
                </TimelineDot>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>First contact</TimelineContent>
        </TimelineItem>

        <TimelineItem>
            <TimelineOppositeContent color="text.secondary">
                2-3 weeks
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot>
                    <GestureIcon/>
                </TimelineDot>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>Sketching ideas</TimelineContent>
        </TimelineItem>

        <TimelineItem>
            <TimelineOppositeContent color="text.secondary">
                2-3 weeks
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot>
                    <AutoFixHighIcon/>
                </TimelineDot>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>Finalising instrumentation and mixing</TimelineContent>
        </TimelineItem>


        <TimelineItem>
            <TimelineSeparator>
                <TimelineDot>
                    <CheckCircleOutlineIcon/>
                </TimelineDot>
            </TimelineSeparator>
            <TimelineContent>Commission Completed!</TimelineContent>
        </TimelineItem>
    </Timeline>
}